import { defineStore } from 'pinia'

import type { InformationArticle } from '../types'
import { useReactiveList } from './utils'

export const useInformationStore = defineStore('information', () => {
  const { list: articles, populate } = useReactiveList<InformationArticle>()

  return { articles, populate }
})
